module.exports = __webpack_public_path__ + "static/media/plane.070962d5.svg";